// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import store from './router/store'
import * as axios from './util/http.js'
import commonPM from './util/common.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/admin.css'
import header from './components/public/Header'
import menu from './components/public/Menu'
import httpConfig from './util/httpConfig'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import echarts from 'echarts' // 引入echarts

Vue.component('m_header', header)
Vue.component('m_menu', menu)
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.prototype.$httpConf = httpConfig
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$messageBox = ElementUI.MessageBox
Vue.prototype.$axios = axios
Vue.prototype.$store = store

Vue.prototype.$echarts = echarts // 引入组件
// 公共方法
Vue.prototype.$pMethod = commonPM

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js